import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Dashboard from '../Dashboard/Dashboard';
import OrdersNew from '../Orders/OrdersNew';
import OrdersNewSuccess from '../Orders/OrdersNewSuccess';

class AppRouter extends React.Component {
  render() {
    const { url } = this.props;
    return (
      <Switch>
        <Route
          exact
          path={`${url}`}
          component={Dashboard}
        />
        <Route
          exact
          path={`${url}orders/new`}
          component={OrdersNew}
        />
        <Route
          exact
          path={`${url}orders/new/success`}
          component={OrdersNewSuccess}
        />
      </Switch>
    );
  }
}

export default AppRouter;



// WEBPACK FOOTER //
// ./src/components/App/AppRouter.js